import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";

const formatHoteldatas = (data) => {
	if (!data) {
		return [];
	}

	const formatItem = (item) => ({
		...item,
		label: `${item.establishment || ""}`,
		value: item._id,
		startDate: item.startDate && moment(item.startDate),
		endDate: item.endDate && moment(item.endDate),
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}

	return formatItem(data);
};

export const {
	fetch: fetchHoteldatas,
	create: createHoteldata,
	update: updateHoteldata,
	delete: deleteHoteldatas,
} = createCrudActions("hoteldata", "Datos de hotel", formatHoteldatas);
